/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import UpdateAxios from "../../axiosComponent/update";
import CreateAxios from "../../axiosComponent/create";
import { DateData } from "../../dynamicComponent/datepick";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import moment from 'moment';
import { setHours, setMinutes } from 'date-fns';
import cogoToast from "cogo-toast";
import 'moment-timezone';
import { translate } from "react-i18next";

export default function StatusHistory(props) {
  const [deliverStatus, setdeliverStatus] = useState(0);
  const [VehicleStatus, setvehicleStatus] = useState([]);

  useEffect(() => {
    getStatus();
  }, []);

  const getStatus = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${props.delivery_id}/vehicle/reporting/history` })
      .then((res) => {
        isEmpty(res.data)
          ? setvehicleStatus([])
          : setvehicleStatus(res.data.data);
      })
      .catch((err) => setvehicleStatus([]));
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      size="tiny"
      centered={true}
      scrolling="true"
    >
      <Modal.Header>
        <div className="d-flex justify-content-between">
          <label className="mt-2 font-weight-normal">{"Status History"}</label>
          <div className="form-inline">
            <i onClick={props.onClose} className="fas fa-times"></i>
          </div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="ui form form-inline">
          <center>
            {VehicleStatus.map((item, index) => {
              return (
                <FormUi.Group inline >
                  <FormUi.Field >
                    <label className="labelName small mr-5">{item.event_code} </label>
                  </FormUi.Field>
                  <FormUi.Field >
                    <label className="labelName small">{item.event_timestamp} </label>
                  </FormUi.Field>
                </FormUi.Group>
              );
            })
            }
          </center>
        </div>
      </Modal.Content>
    </Modal>
  );
};

